import { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { accountsApi } from '../../services/accountsApi';
import { Login } from './';
import { AuthContext } from '../../providers/auth';
import { UserDataContext } from '../../providers/userData';
import { LoadingContext } from '../../providers/loading';
import { t } from 'i18next';

export function LoginContainer() {
  const { state, setState } = useContext(AuthContext);
  const { setUserData } = useContext(UserDataContext);
  const { isLoading, setIsLoading } = useContext(LoadingContext);
  const navigate = useNavigate();

  useEffect(() => {
    if (state.userIsLogged) {
      navigate('/contracts');
    } else {
      navigate('/');
      setIsLoading({ value: false });
    }
  }, []);

  async function signIn(email: string, password: string) {
    try {
      setIsLoading({ value: true });

      const body = `${email}:${password}`;
      const encodedBody = btoa(body);

      await accountsApi.post('/auth', {}, {
        headers: {
          Authorization: 'Basic' + ' ' + encodedBody,
        },
      })
        .then(response => {
          if (response.data.token) {
            localStorage.setItem('user', JSON.stringify(response.data));
            setState({ userIsLogged: true });
            const { name, email, adm } = response.data.infoUser;
            setUserData({
              userName: name,
              userEmail: email,
              admin: adm,
              token: response.data.token
            });
            navigate('/contracts');
          }
          setIsLoading({ value: false });
          return response.data;
        });
    }
    catch (error) {
      console.log(error);
      setIsLoading({ value: false });
      alert(t('wrong-email-password'));
    }
  }

  return (
    <Login
      loadingButton={isLoading.value}
      signIn={signIn}
    />
  );
}
